import {
  Project,
  ProjectsState,
  PublishHistory,
} from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

export type OldPublishHistory = Omit<
  PublishHistory,
  | 'databaseInfo'
  | 'isConsolidatingModels'
  | 'modelHistoriesById'
  | 'modelAliasHistory'
> & {
  connectionInfo: {
    databaseId: string;
    namespaceIri: string;
    namespacePrefix: string;
    shouldAddNamespace: boolean;
    shouldEnableVoicebox?: boolean;
  };
  isPublishingSPG: boolean;
  modelHistory: {
    modelName: string;
    namedGraphIri: string;
  };
};

/**
 *  Migration to add an empty publishHistory field onto all projects
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v21 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v21Projects(prevState.projects);
  }

  return nextState;
};

const v21Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }

    const publishHistory: OldPublishHistory = {
      connectionId: '',
      connectionInfo: {
        databaseId: '', // part of connectionInfo but moved to databaseInfo in v42
        namespaceIri: '',
        namespacePrefix: '',
        shouldAddNamespace: false,
      },
      csvResourceHistoriesById: {},
      doExportProject: true,
      isPublishingRules: true,
      isPublishingSPG: true,
      modelHistory: {
        modelName: '',
        namedGraphIri: '',
      },
      sensitivePropertyGroupsByName: {},
      vgResourceHistoriesById: {},
    };
    projectsById[projectId] = {
      ...project,
      publishHistory: project.publishHistory || { ...publishHistory },
    };
  });

  return { ...prevProjectsState, projectsById };
};
